import { Outlet } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import PATH_PAGE from '@/router/path';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';
import { ArrowLeftIcon } from '@radix-ui/react-icons';

const AiServiceOCRLayout = () => {
  const { workspaceId } = useParamWorkspaceId();

  const navItems = [
    {
      href: PATH_PAGE.dashboard.ai.overview(workspaceId),
      label: 'All Module',
      strictMatch: true,
      separator: true,
      icon: <ArrowLeftIcon />,
    },
    {
      href: PATH_PAGE.dashboard.ai.module(workspaceId, 'typhoon-ocr').overview,
      label: 'Overview',
      strictMatch: true,
    },
    // {
    //   href: PATH_PAGE.dashboard.ai.module(workspaceId, 'typhoon-ocr').playground,
    //   label: 'Playground',
    //   strictMatch: true,
    // },
    // {
    //   href: PATH_PAGE.dashboard.ai.module(workspaceId, 'typhoon-ocr').activity,
    //   label: 'Activity',
    //   strictMatch: true,
    // },
    {
      href: PATH_PAGE.dashboard.ai.module(workspaceId, 'typhoon-ocr').pricing,
      label: 'Pricing',
      strictMatch: true,
    },
  ];

  const navbarConfig = useMemo(
    () => ({
      title: 'Typhoon OCR',
      navbar: navItems,
    }),
    [workspaceId]
  );
  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  return (
    <>

      <Outlet />
    </>
  );
};

export default AiServiceOCRLayout;
